//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapMutations,
  mapState,
  mapGetters
} from "vuex";
export default {
  name: "process-bar",
  data() {
    return {
      initiated: false,
      isHandleTouch: false,
      handlerX: 0,
      PrevX: 0,
      startX: 0
    };
  },
  computed: {
    ...mapGetters([
      'playProcess', 'duration', 'currentTime'
    ]),
  },
  methods: {
    processTouchStart(e) {
      this.initiated = true;
      this.startX = e.touches[0].pageX
      if(!this.isHandleTouch){//没有拖拽的时候，直接跳
        let currX = e.touches[0].pageX - this.$refs.processBar.offsetLeft
        debugger
        this.$store.commit('updateProcess', currX / this.$refs.process.clientWidth )
      }
    },
    processTouchMove(e) {
      if (!this.initiated) return;
      if (!this.isHandleTouch) return;
      let deltaX = e.touches[0].pageX - this.startX
      this.handlerX = Math.min(this.$refs.process.clientWidth, Math.max(0, this.PrevX + deltaX))
    },
    processTouchEnd(e) {
      this.PrevX = this.handlerX
      // console.log(this.startX)
      if(this.isHandleTouch){//拖过来的
        // debugger
        this.$store.commit('updateProcess', this.handlerX / this.$refs.process.clientWidth )
      }
      this.initiated = false;
      this.isHandleTouch = false;
    },
    handlerTouch() {
      this.isHandleTouch = true;
    }
  },
  watch: {
    playProcess(val){
      // console.log(val)
      let currX = this.$refs.process.clientWidth * val
      if(!this.isHandleTouch){
        this.handlerX = currX
        this.PrevX = currX
      }
    }
  },
  components: {}
};




// WEBPACK FOOTER //
// ./src/components/ProcessBar.vue